<template>
  <card :title="computedTitle" :on-cancel="cancel">
    <Form ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveProjectType)">
        <div class="row">
          <div class="col-md-4">
            <material-input-field
              id="projectTypeInput"
              ref="projectTypeInput"
              v-model="projectType"
              :name="'projectType'"
              variant="static"
              :label="$t('projectTypes.projectType') + ' *'"
              :placeholder="$t('projectTypes.projectType')"
            />
            <material-checkbox v-model="preCreatedAssignments">
              {{$t('projectTypes.preCreatedAssignments')}}
            </material-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button type="submit" variant="gradient" color="dark">
              {{$t('common.submit')}}
            </material-button>
          </div>
        </div>
      </form>
    </Form>
  </card>
</template>
<script>
import api from "../../services/api"
import { getApiErrorMessage } from "../../utils/apiError";
import { Form } from 'vee-validate';
import Card from "../../components/Card.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";

export default {
  components: {
    Form,
    Card,
    MaterialInputField,
    MaterialButton,
    MaterialCheckbox
  },
  props: {
    editMode: {
      type: Boolean,
      required: true
    },
    projectTypeProp: {
      type: String,
      required: false,
      default: ''
    },
    projectTypeId: {
      type: Number,
      required: false,
      default: null
    },
    preCreatedAssignmentsProp: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['close', 'refresh-data'],
  data() {
    return {
      isMobile: window.innerWidth <= 1024,
      projectType: this.projectTypeProp,
      preCreatedAssignments: this.preCreatedAssignmentsProp
    };
  },
  computed: {
    computedTitle() {
      return this.editMode ? this.$t('projectTypes.editProjectType') : this.$t('projectTypes.createProjectType');
    },
  },
  created() {
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    },
    cancel()
    {
      this.$emit('close');
    },
    async saveProjectType() {
      if (this.validateInput()) {
        if (this.editMode) {
          await api.put('/ProjectType/' + this.projectTypeId, { type: this.projectType, preCreatedAssignments: this.preCreatedAssignments }).then(() => {
            this.$toast.success(this.$t('projectTypes.projectTypeUpdated'), { timeout: 1500 });

            this.$emit('refresh-data');
            this.$emit('close');
          }).catch(error => {
            console.error(error) // eslint-disable-line no-console
            this.$toast.danger(getApiErrorMessage(this.$t, error), { timeout: 0 });
          });
        }
        else {
          await api.post('/ProjectType', { type: this.projectType, preCreatedAssignments: this.preCreatedAssignments }).then(() => {
            this.$toast.success(this.$t('projectTypes.projectTypeCreated'), { timeout: 1500 });

            this.$emit('refresh-data');
            this.$emit('close');
          }).catch(error => {
            console.error(error) // eslint-disable-line no-console
            this.$toast.danger(getApiErrorMessage(this.$t, error), { timeout: 0 });
          });
        }
      }
    },
    validateInput() {
      let success = true;
      if (this.projectType === '') {
        this.$toast.info(this.$t('errors.newProjectTypeEmpty'), { timeout: 2500 });
        success = false;
      }

      return success;
    }
  },
};
</script>
<style></style>
